import React from 'react';
import { ExternalLink, Smartphone } from 'lucide-react';
import {
  isBotApp,
  toolHasWebUrl,
  toolHasRcAppUrl,
  launchToolAtUrl,
  getStepsPreview,
} from '../../../utils/toolAppSubtype';

const ToolCardActions = ({
  tool,
  userEmail,
  garageAPI,
  onOpenTool,
  onToolLaunch,
  handleLaunchTool,
  showStepsPreview = false,
  maxStepsPreview = 3,
}) => {
  const bot = isBotApp(tool);
  const hasWeb = toolHasWebUrl(tool);
  const hasRc = toolHasRcAppUrl(tool);
  const botSetupPending = bot && tool?.botLaunchOptions?.dynamic && !hasWeb && !hasRc;
  const stepsPreview = showStepsPreview ? getStepsPreview(tool.steps, maxStepsPreview) : [];

  const openDetails = (e) => {
    e.stopPropagation();
    onOpenTool?.(tool.id);
  };

  const openWeb = (e) => {
    e.stopPropagation();
    launchToolAtUrl(tool, tool.url, {
      garageAPI,
      userEmail,
      onToolLaunch: handleLaunchTool || onToolLaunch,
      target: 'web',
    });
  };

  const openRc = (e) => {
    e.stopPropagation();
    launchToolAtUrl(tool, tool.rcAppUrl, {
      garageAPI,
      userEmail,
      onToolLaunch: handleLaunchTool || onToolLaunch,
      target: 'rc_app',
    });
  };

  if (bot) {
    return (
      <>
        {stepsPreview.length > 0 && (
          <ol className="garage-tool-steps-preview">
            {stepsPreview.map((step, idx) => (
              <li key={idx}>
                <span className="garage-tool-step-num">{idx + 1}.</span>
                <span className="garage-tool-step-text">{step}</span>
              </li>
            ))}
          </ol>
        )}
        <div className="garage-tool-actions">
          <button type="button" className="garage-tool-btn garage-tool-btn-secondary" onClick={openDetails}>
            Details
          </button>
          {hasWeb && (
            <button type="button" className="garage-tool-btn garage-tool-btn-primary" onClick={openWeb}>
              <ExternalLink size={14} />
              Web
            </button>
          )}
          {hasRc && (
            <button type="button" className="garage-tool-btn garage-tool-btn-primary" onClick={openRc}>
              <Smartphone size={14} />
              RC app
            </button>
          )}
          {botSetupPending && (
            <span className="garage-tool-launch-unavailable" role="status">
              Conversation setup pending
            </span>
          )}
        </div>
      </>
    );
  }

  return (
    <div className="garage-tool-actions">
      <button type="button" className="garage-tool-btn garage-tool-btn-secondary" onClick={openDetails}>
        <ExternalLink size={14} />
        Details
      </button>
      {(hasWeb || tool.toolType === 'Gem') && (
        <button type="button" className="garage-tool-btn garage-tool-btn-primary" onClick={openWeb}>
          <ExternalLink size={14} />
          Launch
        </button>
      )}
    </div>
  );
};

export default ToolCardActions;
